// libs
import get from "lodash/get";

// components
import Text from "./components/Text";
import Video from "./components/Video";
import Card from "./components/Card";

// constants
import { WIDGET_ITEM_TYPES } from "shared/components/AdPlatformWidgets/constants";

// types
import { ILandingPageWidget } from "shared/components/AdPlatformWidgets/types";

export const getComponent = (type: string, actionType: string) => {
    if (type === WIDGET_ITEM_TYPES.TEXT_ONLY) return Text;
    if (type === WIDGET_ITEM_TYPES.BANNER) {
        if (actionType === "youtube") {
            return Video;
        } else {
            return Card;
        }
    }
};

export const getGridParams = (widget: ILandingPageWidget) => {
    let numOfColumns = get(widget, "widget_data.parameters.no_of_cols_desktop", 1);
    numOfColumns = numOfColumns === "" ? 1 : numOfColumns;

    return {
        title: get(widget, "widget_data.parameters.title", ""),
        titleAlign: get(widget, "widget_data.parameters.title_align_desktop", "left"),
        contentAlign: get(widget, "widget_data.parameters.content_align", ""),
        theme: get(widget, "widget_data.parameters.theme", ""),
        inventoryName: get(widget, "inventory_name", ""),
        backgroundColor: get(widget, "widget_data.parameters.app_bkg_color", "#fff"),
        textColor: get(widget, "widget_data.parameters.app_title_text_color", "#000"),
        numOfColumns,
    };
};
